<template>
  <div class="das-dropdown" @click.stop="toggleList()">
    {{ placeholderText }}
    <sup class="red-asterisk" v-if="!selectedElementCount">*</sup>
    <span class="element-count" v-if="selectedElementCount && selectedElementCount > 1">{{ selectedElementCount }}</span>
    <span class="caret"></span>
    <ul :class="{ 'display-block': showList, 'display-none': !showList }" @click.stop="">
      <div class="list-group" :class="{ 'display-block': showList, 'display-none': !showList }" @click.stop="" v-for="(opts, index) in getListOptions" :key="`${optionField}-${index}`">
        <!-- Group-level checkbox begins -->
        <input type="checkbox" :value="opts" @click.stop="" @change.stop="toggleGroup(opts['key'], opts, $event)" v-model="modelData['group'][opts['key']]" />
        <!-- Group-level checkbox ends -->

        {{ opts[optionField] }}
        <li :class="{ 'display-block': showList, 'display-none': !showList }" @click.stop="" v-for="(opt, opt_index) in opts['value']" :key="`${opts['key']}-${optionField}-${opt_index}`">
          <!-- Elements-level checkbox begins -->
          <input type="checkbox" :value="opt['value']" @click.stop="" @change.stop="toggleSingleElement(opts['key'], opts, opt, $event)" v-model="modelData['elements'][opts['key']]" />
          <!-- Element-level checkbox ends -->
          {{ opt[optionField] }}
        </li>
      </div>
    </ul>
  </div>
</template>

<script>
import { startCase, cloneDeep } from "lodash";

export default {
  name: "das-dropdown-checkbox-grouped",
  props: {
    options: {
      type: Object,
      default: null
    },
    optionField: {
      type: String,
      default: ""
    },
    valueField: {
      type: String,
      default: ""
    },
    input: {
      type: Object,
      default: null
    },
    id: {
      type: String,
      required: false,
      default: null
    },
    showModel: {
      type: Boolean,
      required: false
    }
  },
  data() {
    return {
      abbrevationMappings: {
        Pi: "Principal Investigator",
        SubPi: "Sub-Investigator",
        StudyCoordinator: "Study Coordinator",
        SiteDataLock: "Site-Data Lock",
        HomeHealth: "Home Health",
        Observer: "Observer",
        CallCenter: "Call Center",
        Cra: "Clinical Research Associate (Blinded)",
        CraUB: "Clinical Research Associate (Unblinded)",
        Dm: "Data Management",
        Quality: "Quality",
        StudyAdmin: "Study Admin",
        SystemAdmin: "System Admin"
      },
      showList: false,
      selectedText: null,
      modelData: {},
      placeholderText: null,
      selectedElementCount: 0,
      editResponsePopulatedOnce: false
    };
  },
  methods: {
    toggleList() {
      this.showList = !this.showList;

      this.$root.$emit("close-all-drop-downs", this.id);
    },
    toggleGroup(groupName, optsGroup, event) {
      this.showList = true;
      if (event && event.target && event.target.checked) {
        this.modelData["elements"][groupName] = this.getArrayOfGroupValues(optsGroup["value"]);
      } else {
        this.modelData["elements"][groupName] = [];
      }
      this.$emit("selected-grouped-checkbox-data", cloneDeep(this.modelData["elements"]));
    },
    toggleSingleElement(groupName, group) {
      this.markGroupCheckboxCheckedIfAllElementsChecked(groupName, group);
      this.$emit("selected-grouped-checkbox-data", cloneDeep(this.modelData["elements"]));
    },
    getGroupedElements() {
      if (this.options) {
        if (this.modelData && Object.keys(this.modelData).length === 0) {
          const groups = Object.keys(this.options);

          /* For group-level checkbox */
          this.$set(this.modelData, "group", {});

          /* For element-level checkboxes */
          this.$set(this.modelData, "elements", {});
          for (let i = 0; i < groups.length; i++) {
            /* For group-level checkbox */
            this.$set(this.modelData["group"], groups[i], false);

            /* For element-level checkboxes */
            this.$set(this.modelData["elements"], groups[i], []);
          }
        }
      }
    },
    convertCamelCaseToNormalCase(str) {
      return startCase(str);
    },
    getArrayOfGroupValues(groupArray) {
      const resultantArr = [];
      for (let i = 0; i < groupArray.length; i++) {
        resultantArr.push(groupArray[i]["value"]);
      }
      return resultantArr;
    },
    markGroupCheckboxCheckedIfAllElementsChecked(groupName, group) {
      if (group["value"] && group["value"].length && group["value"].length == this.modelData["elements"][groupName].length) {
        /* If all the elements in a group are selected, then make group checkbox -> checked */

        this.modelData["group"][groupName] = true;
      } else {
        /* If some out of all the elements in a group are selected, then make group checkbox -> unchecked */

        this.modelData["group"][groupName] = false;
      }
    },
    populateSavedResponseForEdit(groups) {
      if (this.input) {
        Object.keys(this.input).forEach(groupName => {
          this.$set(this.modelData["elements"], groupName, this.input[groupName]);
          if (groups) {
            groups.forEach(group => {
              if (groupName === group["key"]) {
                this.markGroupCheckboxCheckedIfAllElementsChecked(groupName, group);
              }
            });
          }
        });
      }
      this.editResponsePopulatedOnce = true;
    },
    getPlaceholderTextValues(groups) {
      this.selectedElementCount = 0;
      groups &&
        groups.forEach(group => {
          this.selectedElementCount = this.selectedElementCount + (this.modelData["elements"][group["key"]] && this.modelData["elements"][group["key"]].length);
          if (this.selectedElementCount == 1) {
            if (this.modelData["elements"][group["key"]] && this.modelData["elements"][group["key"]].length) {
              this.placeholderText = this.abbrevationMappings[this.modelData["elements"][group["key"]][0]];
            }
          } else if (this.selectedElementCount == 0) {
            this.placeholderText = "Select Roles to Notify";
          } else {
            this.placeholderText = "Roles Selected";
          }
        });
    }
  },
  computed: {
    getListOptions() {
      const opts = [];

      this.getGroupedElements();
      Object.keys(this.options).forEach(o => {
        const opt = {
          text: this.convertCamelCaseToNormalCase(o),
          key: o,
          value: this.options[o]
        };
        opts.push(opt);
      });

      if (!this.editResponsePopulatedOnce) {
        this.populateSavedResponseForEdit(opts);
      }
      this.getPlaceholderTextValues(opts);
      return opts;
    }
  },
  mounted() {
    this.$root.$on("close-all-drop-downs", data => {
      if (data == "all" || data !== this.id) {
        this.showList = false;
      }
    });
  },
  watch: {
    input: {
      deep: true,
      handler: function() {
        this.editResponsePopulatedOnce = false;
      }
    },
    showModel() {
      this.showList = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.display-block {
  display: block;
}

.display-none {
  display: none;
}

.dd-placeholder {
  color: #b0bac9;
  font-size: 13px;
  padding: 7px 17px !important;
  font-weight: normal;
}

.das-dropdown {
  border: solid 1px #d3dfe4;
  padding: 6px 17px;
  border-radius: 3px;
  position: relative;
  cursor: pointer;
  margin-bottom: 15px;

  .red-asterisk {
    color: #f16559;
    font-size: 14px;
    font-weight: bold;
    top: -0.2em;
  }

  .element-count {
    color: #4c8ce4;
    background-color: #d3dfe4;
    padding: 0.2px 6px 1px 5.5px;
    border-radius: 2px;
    margin-left: 9px;
    font-size: 12px;
    font-weight: 600;
    position: absolute;
    top: 7px;
  }

  .caret {
    width: 0;
    height: 0;
    border-left: 7px solid transparent;
    border-right: 7px solid transparent;
    border-top: 6px solid #b0bac9;
    top: 14px;
    right: 7px;
    position: absolute;
  }

  ul {
    font-family: RobotoRegular;
    font-size: 15px;
    color: #525252;
    margin: 0;
    padding: 6px 10px;
    list-style: none;
    position: absolute;
    z-index: 9;
    top: 0;
    width: 100%;
    max-height: 200px;
    overflow: auto;
    left: 0;
    //box-shadow: 0 1px 0px 0 rgba(230, 230, 230 , 2%), 0 1px 9px 0 rgba(230, 230, 230 , 100%);
    box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.25);
    background: #ffffff;

    .list-group {
      padding: 8px 0;
    }
    li {
      display: block;
      text-decoration: none;
      color: rgba(0, 0, 0, 0.56);
      /* border-top: 1px solid #ffffff; */
      padding: 5px 15px 5px 15px;
      background: #ffffff;
      margin-left: 1px;
      white-space: nowrap;

      &:hover {
        background: rgba(0, 0, 0, 0.025);
      }
    }
    input[type="checkbox"] {
      box-sizing: border-box;
      cursor: pointer;
      padding: 0;
      margin-right: 11px;
      margin-top: auto;
      margin-bottom: auto;
      top: 2px;
      bottom: 0px;
      position: relative;
      width: 16px;
      height: 16px;
      border-radius: 4px;
      border: none;
    }
  }

  ul::-webkit-scrollbar {
    height: 3px;
  }

  ul::-webkit-scrollbar-thumb {
    background-color: #c4c4c4;
    border-radius: 4px;
    height: 3px;
    border: 3px solid transparent;
  }

  ul::-webkit-scrollbar-track {
    background: transparent;
  }

  ul::-webkit-scrollbar {
    width: 4px;
  }
}
</style>
